import useStyles from './useStyles'
import { Checkbox, Tooltip, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import ModalMenuItem from '../../ModalMenu/ModalMenu'

function TableItem ({
  item,
  setLoading,
  allChecked,
  setAllChecked,
  elementsChecked,
  setElementsChecked,
  getRecycleRequest
}) {
  const classes = useStyles()
  const [checked, setChecked] = useState(false)

  // handle change check-box value
  const handleChange = (event) => {
    setChecked(event.target.checked)
    if (event.target.checked) {
      if (!elementsChecked.includes(item)) {
        setElementsChecked((elements) => [...elements, item])
      }
    } else if (elementsChecked.includes(item)) {
      if (allChecked) {
        setAllChecked(false)
      }
      const elementsFilter = elementsChecked.filter(
        (element) => element._id !== item._id
      )
      setElementsChecked(elementsFilter)
    }
  }
  // update checked by allCheck changes
  useEffect(() => {
    if (allChecked) {
      setChecked(true)
      if (!elementsChecked.includes(item)) {
        setElementsChecked((elements) => [...elements, item])
      }
    } else if (!allChecked && elementsChecked.length === 0) {
      setChecked(false)
    }
  }, [allChecked])

  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        '/' +
        (newDate.getMonth() + 1) +
        '/' +
        newDate.getFullYear()
    } else {
      formattedDate = ''
    }
    return formattedDate
  }

  const getNameFinal = (name) => {
    const chars = name.split('')
    if (chars.length > 35) {
      return (
        <Tooltip title={name}>
          <Typography className={classes.pathTextName}>{chars}</Typography>
        </Tooltip>
      )
    }
    return name
  }

  const getRoutesFinal = (route) => {
    const routes = route.split('/')
    routes.shift()
    if (routes.length > 2) {
      const chars = routes[routes.length - 1].toString().split('')
      if (chars.length > 30) {
        return (
          <Tooltip title={routes}>
            <Typography className={classes.pathText}>
              {/* {routes} */}
              {'../' +
                routes.slice(-2, -1).join('/') +
                '/'.concat(chars.slice(0, -30).join('') + '...')}
            </Typography>
          </Tooltip>
        )
      } else {
        return (
          <Tooltip title={route}>
            <Typography className={classes.pathText}>
              {'../' + routes.slice(-2).join('/')}
            </Typography>
          </Tooltip>
        )
      }
    }
    return route
  }

  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemCheck}>
          <Checkbox checked={checked} onChange={handleChange} />
        </td>

        <td className={classes.itemName}>{getNameFinal(item.name)}</td>
        <td className={classes.itemAbsolutePath}>
          {getRoutesFinal(item.absolutePath)}
        </td>
        <td className={classes.itemPurgeActionUser}>{item.purgeActionUser}</td>
        <td className={classes.itemPurgeDate}>{formatDate(item.purgeDate)}</td>

        <td className={classes.itemKebab}>
          <ModalMenuItem
            item={item}
            getRecycleRequest={getRecycleRequest}
            setLoading={setLoading}
          />
        </td>
      </tr>
    </>
  )
}

export default TableItem
